<template>
  <div>
    <div class="sunshine-port">
      <Crumbs :info="info" :title="navList[0]" />
      <div class="port-container-terrace">
        <div class="port-nav">
          <MenuComBToB :navList="navList" />
        </div>
        <div class="port-content">
          <!-- 书写内容区域 -->
          <div class="content-nav">
            <ul class="nav-title">
              <li
                v-for="(item, index) in tabList"
                :key="index"
                :class="[
                  item.isFlex ? 'full-title' : '',
                  idx === index ? 'active-li' : ''
                ]"
                @click="idx = index"
              >
                {{ item.label }}
              </li>
            </ul>
            <div class="content-text">
              <div v-if="idx === 0" class="business-text">
                <p>2020年6月12日，海关总署发布《关于开展跨境电子商务企业对企业出口监管试点的公告》（海关总署公告2020年第75号），增列“9710”（跨境电商B2B直接出口）和“9810”（跨境电商出口海外仓）两个新的海关监管方式。“9710”适用境内企业通过跨境电商平台与境外企业达成交易后，通过跨境物流将货物直接出口送达境外企业；“9810”适用境内企业将出口货物通过跨境物流送达海外仓，通过跨境电商平台实现交易后从海外仓送达购买者；并根据海关要求传输相关电子数据的，按照本公告接受海关监管。</p>
                <img src="../../../assets/images/BToB/lc.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuComBToB from "./common/menuComBToB.vue";
import Crumbs from "../SunShine/common/Crumbs.vue";
import { navList, flowTabList } from "../../../model/bToB";
export default {
  components: {
    MenuComBToB,
    Crumbs
  },
  data() {
    return {
      info: {},
      navList,
      tabList:flowTabList,
      idx: 0
    };
  },
  created() {
    const path = this.$route.fullPath;
    const index = navList.findIndex(item => item.path === path);
    if (index !== -1) {
      this.info = navList[index];
    }
  }
};
</script>

<style scoped>
.business-text dl{
  display: flex;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
}
.business-text dl dd{
  margin-left: 10px;
}
.nav-title {
  display: flex;
  height: 50px;
  background: #eef0f4;
  border-radius: 8px 8px 0px 0px;
  line-height: 50px;
  width: 100%;
  border-bottom: 3px solid #D3D3D3;
  margin-bottom: 30px;
}
.nav-title .full-title {
  flex: 1;
}
.nav-title li {
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  padding-left: 25px;
  padding-right: 10px;
  cursor: pointer;
}
.nav-title .active-li {
  border-radius: 8px 8px 0px 0px;
  background: #F47310;
  color: #fff;
}
.content-nav {
  width: 796px;
  margin: 0 auto;
}
.port-nav {
  margin-right: 42px;
}
.port-container-terrace {
  width: 1200px;
  height: 797px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex: 1;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
.advantage-box p{
  text-indent: 0;
  margin: 0;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/BToB/Terrace.vue